import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast';
import { useToast } from '@/hooks/use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, ...props }) => (
        <Toast key={id} {...(props as React.HTMLAttributes<HTMLDivElement>)}>
          <div className="grid gap-1">
            {title != null && <ToastTitle>{title as React.ReactNode}</ToastTitle>}
            {description != null && (
              <ToastDescription>{description as React.ReactNode}</ToastDescription>
            )}
          </div>
          {action as React.ReactNode}
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
